export default __webpack_public_path__ + "static/media/NMT.1c67f245.png";